import MiniSearch from 'minisearch';
import { randomHash } from '@/helpers/index';
import { removeAccents } from '@/helpers/string';

export const STOP_WORDS = Object.freeze([
  'o', 'a', 'do', 'da', 'dos', 'das', 'no', 'na',
  'e', 'de', 'em', 'ou', 'para', 'c/', 's/',
]);

function invokeOrDefault(fn, args, defaultValue = null) {
  return typeof fn === 'function' ? fn(args) : defaultValue;
}

function prepareItems(items, options = {}) {
  return items.map(item => ({
    id: item.id || randomHash(),
    content: invokeOrDefault(options.content, item),
    ...invokeOrDefault(options.extract, item, {}),
    item,
  }));
}

function makeTermProcessor(stopWords = []) {
  return (term) => {
    term = removeAccents(term.toLowerCase());
    return stopWords && stopWords.includes(term) ? null : term;
  };
}

export function create(items, options = {}) {
  const preparedItems = prepareItems(items, options);

  const filter = ({ item }) => (
    invokeOrDefault(options.filter, item, true)
  );

  const miniSearch = new MiniSearch({
    fields: options.fields || ['content'],
    storeFields: ['id', 'item'],
    processTerm: makeTermProcessor(STOP_WORDS),
    searchOptions: {
      fuzzy: 0.1,
      prefix: true,
      processTerm: makeTermProcessor(),
      filter,
    },
  });

  miniSearch.addAll(preparedItems);

  return {
    items,
    search(query) {
      const results = query ? miniSearch.search(query) : preparedItems.filter(filter);
      return results.map(({ item }) => item);
    },
  };
}

export default create;
